import Vue from 'vue'
import axios from 'axios'

export default {
    state: {
        chatMessages: {}
    },

    actions: {
        'chatMessagesModel/fetchChatMessages': function (context, data) {
            let chatId = data.chatId,
                callback = data.callback;

            axios.get('/api/chatMessages', {
                params: {
                    chatId
                }
            }).then(
                (response) => {
                    if (!response.data.errors) {
                        context.commit('chatMessagesModel/setChatMessages', {chatId, messages: response.data});
                    }

                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                }
            )
        },

        'chatMessagesModel/sendMessage'(context, data){

            axios.post('/api/chatMessages', {
                chatId: data.chatId,
                message: data.message
            });
        },

        'chatMessagesModel/updateReadStatus'(context, data){
            axios.post('/api/chatMessages/updateReadStatus', {
                chatId: data.chatId
            });
        }
    },

    mutations: {
        'chatMessagesModel/setChatMessages': function (state, data) {
            Vue.set(state.chatMessages, data.chatId, data.messages);
        }
    }

}


// WEBPACK FOOTER //
// ./src/ChatRoom/chatMessagesModel.js